import { booleanAttribute, Directive, Input } from '@angular/core';

@Directive({
    selector: 'nova-grid-toggle',
    standalone: true
})
export class GridToggleDirective {
    @Input() field: string;
    @Input() label: string;
    @Input() value: any;
    @Input({ transform: booleanAttribute }) checked: boolean = false;
    @Input({ transform: booleanAttribute }) disabled: boolean = false;
    @Input() matTooltip: string;
}
